import React from "react";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import GitHubIcon from "@material-ui/icons/GitHub";
import BookIcon from "@material-ui/icons/Book";
import content from "../utils/content.json";

function Header() {
  return (
    <header
      className="main-header"
      style={{ backgroundImage: `url('/images/bg.jpg')` }}
    >
      <div className="container">
        <div className="row personal-profile">
          <div className="col-md-4 personal-profile__avatar">
            <img
              className=""
              src={content.content.profile.avatar}
              alt="avatar"
            />
          </div>
          <div className="col-md-8">
            <p className="personal-profile__name">
              {content.content.profile.name}
            </p>
            <p className="personal-profile__work">
              {content.content.profile.work}
            </p>
            <div className="personal-profile__contacts">
              <dl className="contact-list contact-list__opacity-titles">
                <dt>Phone:</dt>
                <dd>
                  <a href={`tel:${content.content.profile.contacts.phone}`}>
                    {content.content.profile.contacts.phone}
                  </a>
                </dd>
                <dt>Email:</dt>
                <dd>
                  <a href={`mailto:${content.content.profile.contacts.email}`}>
                    {content.content.profile.contacts.email}
                  </a>
                </dd>
                <dt>Address:</dt>
                <dd>{content.content.profile.contacts.address}</dd>
              </dl>
            </div>
            <p className="personal-profile__social">
              <a
                href={content.content.profile.social.github}
                target="_blank"
                rel="noreferrer"
              >
                <GitHubIcon />
              </a>
              <a
                href={content.content.profile.social.linkedin}
                target="_blank"
                rel="noreferrer"
              >
                <LinkedInIcon />
              </a>
              <a
                href={content.content.profile.social.substack}
                target="_blank"
                rel="noreferrer"
                title="Substack"
              >
                <BookIcon />
              </a>
            </p>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
